import angular from 'angular';

angular.module('container', []);
